import {firstValueFrom} from 'rxjs';
import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';
import {SPHERE} from './sphere.namespace';

export interface IRPatientImportantInformation {
  view: boolean;
  data: SPHERE.ISphere;
  patientId?: string;
  serviceId?: string;
  openSphere: boolean; // Abrir esfera
}

export namespace PatientSphereAction {
  export class ShowSphereBubble {
    static readonly type = '[PatientImportantInformation] Show BubblePatientInformationAction';
    constructor(public show: boolean, public patientId: string, public serviceId: string) { }
  }

  export class ShowOrHideBubble {
    static readonly type = '[PatientImportantInformation] Show Or Hide Bubble';
    constructor(public showOrHide: boolean) { }
  }

  export class GetPatientSphere {
    static readonly type = '[PatientImportantInformation] Get Patient Relevant Data Action';
    constructor() { }
  }

  export class OpenSphere {
    static readonly type = '[PatientImportantInformation] Open Sphere Action';
    constructor(public openSphere: boolean) { }
  }

}

@State<IRPatientImportantInformation>({
  name: 'PatientSphereState',
  defaults: {
    view: false,
    data: null,
    openSphere: false,
  },
})
@Injectable()
export class PatientSphereState {
  constructor(
    private baseService: BaseService<any>
  ) { }

  url = environment.SERVER_URL;

  @Selector()
  public static getShowBubble(state: IRPatientImportantInformation): boolean {
    return state.view;
  }

  @Selector()
  public static getPatientRelevantData(state: IRPatientImportantInformation): SPHERE.ISphere {
    return state.data;
  }

  @Selector()
  public static isSphereOpen(state: IRPatientImportantInformation): boolean {
    return state.openSphere;
  }

  @Action(PatientSphereAction.ShowSphereBubble)
  async ShowBubblePatientInformationAction(ctx: StateContext<IRPatientImportantInformation>, action?: PatientSphereAction.ShowSphereBubble): Promise<void> {
    ctx.patchState({
      view: action.show,
      patientId: action.patientId,
      serviceId: action.serviceId
    });
  }

  @Action(PatientSphereAction.GetPatientSphere)
  async getPatientRelevantDataAction(ctx: StateContext<IRPatientImportantInformation>, _?: PatientSphereAction.GetPatientSphere): Promise<void> {
    const { patientId, serviceId } = ctx.getState();
    const response: DataBaseServiceResponse<SPHERE.ISphere> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${patientId}/service/${serviceId}/records/sphere`)
    );

    if (response.error) throw new Error(response.message);


    ctx.patchState({
      data: response.entity
    });
  }

  @Action(PatientSphereAction.ShowOrHideBubble)
  async ShowOrHideBubbleAction({patchState}: StateContext<IRPatientImportantInformation>, {showOrHide}: PatientSphereAction.ShowOrHideBubble): Promise<void> {
    patchState({view: showOrHide});
  }

  @Action(PatientSphereAction.OpenSphere)
  async OpenSphere({patchState}: StateContext<IRPatientImportantInformation>, action: PatientSphereAction.OpenSphere): Promise<void> {
    patchState({openSphere: action.openSphere});
  }
}
